export * from "./registry/getXpsConfig";
export * from "./registry/getCookieConfig";
